<script setup>
import { ref, onMounted } from "vue";
import Instagram from "@/components/advanced/Instagram.client.vue";
const isVisible = ref(false);
const target = ref(null);

onMounted(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        isVisible.value = true;
        observer.disconnect(); // Yüklendikten sonra Observer'ı durdur
      }
    },
    { threshold: 0.1 } // %10'u görünür olunca tetiklenir
  );

  if (target.value) {
    observer.observe(target.value);
  }
});
</script>

<template>
  <div ref="target" class="min-h-[300px] flex justify-center items-center">
    <Instagram v-if="isVisible" />
    <div v-else class="text-gray-400 text-xl animate-pulse">📸 Yükleniyor...</div>
  </div>
</template>
